import React from 'react';
import { NewspaperIcon, DownloadIcon } from 'lucide-react';
export function LatestIssueCallout() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2241">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2242">
        <div className="flex flex-col sm:flex-row items-start gap-6 p-6 rounded-xl shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-2243">
          <div className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0" style={{
          backgroundColor: 'rgba(200,168,75,0.15)'
        }} data-id="element-2244">
            <NewspaperIcon size={32} style={{
            color: '#c8a84b'
          }} data-id="element-2245" />
          </div>
          <div className="flex-1" data-id="element-2246">
            <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2247">
              Latest Issue
            </p>
            <h2 className="text-2xl font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-2248">
              The Manual — April 2025
            </h2>
            <p className="text-sm mb-4" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2249">
              In this issue: From the Editor, Calling All Members, Upcoming
              Activities, First Line Intelligence, Legal Notes, Range Rule
              Highlight, and more.
            </p>
            <a href="#" className="inline-flex items-center gap-2 py-2.5 px-5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2250">
              <DownloadIcon size={16} data-id="element-2251" />
              Download Latest Issue (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>;
}